import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=54e321a8&scoped=true&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e321a8",
  null
  
)

export default component.exports